var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 413,
    height: 352,
    viewBox: "0 0 413 352",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M367.516 240.218C374.386 240.218 379.957 234.648 379.957 227.777C379.957 220.906 374.386 215.335 367.516 215.335C360.646 215.335 355.075 220.906 355.075 227.777C355.075 234.648 360.646 240.218 367.516 240.218Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343.622 274.93C348.316 274.93 352.118 271.126 352.118 266.434C352.118 261.741 348.316 257.937 343.622 257.937C338.93 257.937 335.125 261.741 335.125 266.434C335.125 271.126 338.93 274.93 343.622 274.93Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3149 67.2534C73.0074 67.2534 76.8115 63.4493 76.8115 58.7568C76.8115 54.0643 73.0074 50.2603 68.3149 50.2603C63.6224 50.2603 59.8184 54.0643 59.8184 58.7568C59.8184 63.4493 63.6224 67.2534 68.3149 67.2534Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4253 231.114C25.14 231.114 32.2046 224.05 32.2046 215.335C32.2046 206.621 25.14 199.556 16.4253 199.556C7.71063 199.556 0.645996 206.621 0.645996 215.335C0.645996 224.05 7.71063 231.114 16.4253 231.114Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M208.052 310.316C293.018 310.316 361.901 241.433 361.901 156.164C361.901 70.8951 293.018 2.01221 208.052 2.01221C123.087 2.01221 54.2041 70.8951 54.2041 156.164C54.2041 241.433 123.087 310.316 208.052 310.316Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M297.399 25.1812C301.975 25.1812 305.848 28.6839 305.848 33.588V281.585C305.848 286.139 302.327 289.992 297.399 289.992H114C109.424 289.992 105.552 286.489 105.552 281.585V33.588C105.552 29.0342 109.072 25.1812 114 25.1812H297.399Z",
    fill: "#CED7E2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M305.849 51.1031V281.236C305.849 285.79 302.328 289.643 297.4 289.643H129.842L115.057 274.931L281.559 46.8997L295.992 41.6455L305.849 51.1031Z",
    fill: "#BCC4CF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M296.696 44.4475C296.696 43.0465 295.64 41.6455 293.88 41.6455H117.873C116.465 41.6455 115.057 42.6963 115.057 44.4475V272.129C115.057 273.53 116.113 274.931 117.873 274.931H293.528C294.936 274.931 296.344 273.881 296.344 272.129L296.696 44.4475Z",
    fill: "#D9DFEE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M296.695 44.4475C296.695 43.0465 295.639 41.6455 293.879 41.6455H117.873C116.464 41.6455 115.056 42.6963 115.056 44.4475C117.168 135.17 117.873 237.802 108.016 264.423L276.63 261.971C286.839 215.734 294.583 132.718 296.695 44.4475Z",
    fill: "#EFF3FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7240_42154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.343 41.9951C296.343 41.9951 295.991 55.6561 291.767 142.876C291.767 143.576 291.767 143.926 291.767 144.627C286.487 230.095 210.452 247.959 201.299 249.01C197.075 249.36 188.979 250.061 174.546 250.061C156.594 250.761 129.137 251.112 86.1911 251.462C84.7831 251.462 83.7271 250.061 84.4311 248.66C114 189.463 114.352 42.3456 114.352 42.3456L296.343 41.9951Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M291.416 144.277C286.487 229.745 210.101 247.61 200.948 248.661C196.724 249.011 188.628 249.711 174.195 249.711C212.213 232.197 232.629 200.672 232.277 176.152C250.582 177.554 282.263 176.152 291.416 144.277Z",
    fill: "#EAEEF9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M248.47 25.8822C248.47 25.5319 248.47 25.5319 248.47 25.8822L246.71 24.1308C246.71 24.1308 245.654 24.4811 245.302 25.1816H217.844C217.844 24.4811 217.844 24.1308 217.844 23.4303C217.844 17.8258 212.916 12.9219 207.284 12.9219C201.652 12.9219 196.724 17.8258 196.724 23.4303C196.724 24.1308 196.724 24.4811 197.076 24.8314H168.563C167.155 24.8314 165.747 25.8822 165.747 27.9839V37.0912C165.747 44.0966 170.675 48.3 177.363 48.3H235.797C242.837 48.3 248.822 44.0966 248.822 37.0912V27.6336C249.174 26.9331 248.822 26.2325 248.47 25.8822Z",
    fill: "#1C3754"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247.413 25.8814V34.9885C247.413 35.6891 247.413 36.0393 247.413 36.74C246.357 42.6948 241.429 47.5986 235.093 47.5986H176.307C169.971 47.5986 165.042 42.6948 163.986 36.74C163.986 36.0393 163.986 35.6891 163.986 34.9885V25.8814C163.986 24.4802 165.042 22.7288 166.802 22.7288H195.668C195.668 22.0283 195.668 21.678 195.668 21.3277C195.668 15.7232 200.596 10.8193 206.228 10.8193C211.86 10.8193 216.788 15.7232 216.788 21.3277C216.788 22.0283 216.788 22.3786 216.788 22.7288H245.653C246.357 23.0791 247.413 24.1299 247.413 25.8814Z",
    fill: "url(#paint0_linear_7240_42154)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M205.524 26.2321C208.34 26.2321 210.452 24.1304 210.452 21.3282C210.452 18.526 208.34 16.4243 205.524 16.4243C202.708 16.4243 200.596 18.526 200.596 21.3282C200.596 24.1304 203.06 26.2321 205.524 26.2321Z",
    fill: "#EAEEF9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M247.061 36.7412C246.005 42.6958 241.077 47.5998 234.741 47.5998H176.307C169.971 47.5998 165.042 42.6958 163.986 36.7412H247.061Z",
    fill: "#9AA1B2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M158.355 143.225C163.987 143.225 168.211 138.671 168.211 133.417C168.211 127.813 163.635 123.609 158.355 123.609C152.723 123.609 148.499 128.163 148.499 133.417C148.147 138.671 152.723 143.225 158.355 143.225Z",
    fill: "#989FB0"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M236.5 142.876C242.133 142.876 246.357 138.322 246.357 133.068C246.357 127.463 241.781 123.26 236.5 123.26C231.22 123.26 226.644 127.814 226.644 133.068C226.644 138.322 230.868 142.876 236.5 142.876Z",
    fill: "#989FB0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M206.932 153.735H187.923V158.288H206.932V153.735Z",
    fill: "#989FB0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M396.668 43.0459C404.412 79.4752 403.355 118.006 392.795 153.734C390.331 161.09 387.868 169.147 382.588 174.751C375.196 183.508 361.816 187.361 350.904 184.559C339.64 181.757 330.488 171.949 328.376 160.039C326.616 152.683 329.08 143.926 335.416 139.373C342.104 135.169 351.608 136.22 357.24 141.475C363.576 146.729 366.04 154.785 365.688 162.491C365.336 170.197 362.52 177.903 358.648 184.559C347.032 206.276 325.912 223.44 301.624 231.146C283.671 236.75 264.31 236.75 246.357 231.847",
    stroke: "#C9D4E2",
    strokeWidth: 6.06897,
    strokeMiterlimit: 10,
    strokeDasharray: "12.14 12.14"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M411.452 32.5371C410.396 36.39 406.172 37.7914 401.948 35.3392C397.372 33.2375 394.204 31.4863 394.908 27.9834C395.964 24.4806 400.188 24.1303 405.116 23.7801C411.1 23.0795 412.156 28.684 411.452 32.5371Z",
    fill: "#DAE2EB"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M377.308 36.0401C379.068 39.1926 383.996 41.2943 387.516 38.1418C391.388 34.6388 394.556 32.1869 392.796 28.6842C391.036 25.5316 388.22 26.5825 382.236 27.283C377.308 28.3339 375.196 32.5371 377.308 36.0401Z",
    fill: "#DAE2EB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M392.795 23.0805C395.259 22.7302 397.723 24.1313 398.427 26.233C398.779 26.9336 399.131 27.9844 399.131 28.685C399.835 33.5888 398.075 37.7922 395.259 38.1424C392.091 38.843 388.923 35.3403 388.571 30.7868C388.571 29.3855 388.571 28.685 388.571 27.6341C388.923 25.1822 390.331 23.4308 392.795 23.0805C393.147 23.0805 392.795 23.0805 392.795 23.0805Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7240_42154",
    x: 17.4484,
    y: 8.61581,
    width: 345.653,
    height: 342.984,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 33.3793
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.3793
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7240_42154"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7240_42154",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_42154",
    x1: 164.087,
    y1: 29.2136,
    x2: 247.494,
    y2: 29.2136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/Maintenance.1e2b56d5e5ea7ca5a2ea4fbef1dbe124.svg";
export { ForwardRef as ReactComponent };